import { lazy } from "react";
import { LayoutDashboard } from "lucide-react";

import type { FeatureDescriptor } from "@/features/types";

export const dashboardFeature: FeatureDescriptor = {
  id: "dashboard",
  flag: "dashboard",
  path: "/",
  group: "operate",
  index: true,
  navKey: "nav.dashboard",
  icon: LayoutDashboard,
  element: lazy(() => import("./DashboardPage")),
  // No scope controls: the dashboard is always the system-wide view. It never
  // reads the header locality/time-range, so both selectors are hidden here. Every
  // page reached from it opens on that same scope (see `ScopeControls.systemWide`),
  // so a figure does not change between the dashboard and the page it links to.
  scope: { locality: false, days: false, systemWide: true },
};
